import { toggleIsLoading } from './loading';
import messageActions from './message';
import managerConstants from '../constants/manager';
import managerService from '../services/manager';

const managerCreate = detail => ({ type: managerConstants.CREATE_MANAGER, detail });
const managerList = data => ({ type: managerConstants.LIST_MANAGER, data });
const managerUpdate = detail => ({ type: managerConstants.UPDATE_MANAGER, detail });
const managerDestroy = managerId => ({ type: managerConstants.DELETE_MANAGER, managerId });
const managerClear = () => ({ type: managerConstants.CLEAR_MANAGER });

const managerActions = {};

managerActions.clearManager = () => {
  return dispatch => {
    dispatch(managerClear());
  };
};

managerActions.create = data => {
  return dispatch => {
    dispatch(toggleIsLoading(true));
    managerService
      .create(data)
      .then(response => {
        dispatch(managerCreate(response));
        dispatch(managerActions.list());
        dispatch(toggleIsLoading(false));
      })
      .catch(err => {
        dispatch(toggleIsLoading(false));
        dispatch(messageActions.setErrorMessage(err.message));
      });
  };
};

managerActions.list = () => {
  return dispatch => {
    dispatch(toggleIsLoading(true));
    managerService
      .list()
      .then(response => {
        dispatch(managerList(response));
        dispatch(toggleIsLoading(false));
      })
      .catch(err => {
        dispatch(toggleIsLoading(false));
        dispatch(messageActions.setErrorMessage(err.message));
      });
  };
};

managerActions.update = (data, managerApiKey) => {
  return dispatch => {
    dispatch(toggleIsLoading(true));
    managerService
      .update(data, managerApiKey)
      .then(response => {
        dispatch(managerUpdate(response));
        dispatch(managerActions.list());
        dispatch(toggleIsLoading(false));
      })
      .catch(err => {
        dispatch(toggleIsLoading(false));
        dispatch(messageActions.setErrorMessage(err.message));
      });
  };
};

export default managerActions;



/** WEBPACK FOOTER **
 ** ./src/actions/managers.js
 **/